import Dashboard from './dashboard'
import Administration from './administration'
import AdminUsers from './adminUsers'
import InstitutionUsers from './institutionUsers'
import ServiceProviderDetails from './serviceProviderDetails'
import ProductDetails from './productDetails'
import ProductComments from './productComments'
import Audit from './audit'
import Reports from './report'
import ApiCalls from './apiCalls'
import ApiCallDetails from './apiCallDetails'

export default [
    Dashboard,
    Administration,
    AdminUsers,
    InstitutionUsers,
    ServiceProviderDetails,
    ProductDetails,
    ProductComments,
    Audit,
    Reports,
    ApiCalls,
    ApiCallDetails
]